/*
Author: Shivakumar
Date: 04/12//2019
Integration implementation changes : [onboarding V1.1][LOP/RLOP in RUN PAYROLL] If LOP added in current month ie. Dec, on running payroll for previous months ie. November or October, it's getting reflected.
search_string: PL-1974
*/

/*
Author: Vinod
Date: 05/12//2019
Issue: Getting success message pop up even when payroll is failing.
search_string: PL-2010
*/

/*
Author: Shivakumar
Date: 09/12//2019
Issue: [Summary] Not able to add, mistake in month name
search_string: PL-2264
*/

/*
Author: Shivakumar
Date: 31/03//2020
Description : [Run Pay Roll Summary Page] Summary Page Getting Cancelled.
search_string: PL_2957
*/

<template>
  <div class="summaryDiv">
    <div class="margin-top-30 margin-bottom-100">
      <toast-message
        :message="errmsg"
        type="error"
        :isToastEnable="toast"
        @close="(val) => toast = val"
      />
      
      <!-- Here added employee data-table By Bhushan Tipre -->
      <!-- <tl-accordion headerName="Select Employee">
        <template v-slot:accordionBody>
          <data-table
            :columns="employeeTableColumns"
            :tableData="employeeData"
            :showinrow="false"
            :checkbox="true"
            @selected="selected"
            @deselected="deselected"
            @headerSelection="headerCheckBoxChange"
          ></data-table>
        </template>
      </tl-accordion> -->
        <!-- End Here -->

      <table>
        <tr></tr>
        <tr v-for="(item, index) in offCycleData" :key="index">
          <td>{{item.name}}</td>
          <td>{{item.count}}</td>
        </tr>
      </table>
    </div>
    <pop-up-message v-if="showModal" :message="responseMessage" btnText="OK" @back="closeModal()"></pop-up-message>
    <bottom-action-container>
      <template slot="end">
        <btn-grp>
          <btn text="Cancel" type="secondary" @click="cancel" />
          <btn text="Run Payroll" type="primary" @click="runPayrollClick()" />
        </btn-grp>
      </template>
    </bottom-action-container>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  data() {
    return {
      errmsg: "",
      responseMessage: "",
      toast: false,
      // PL_2957
      // tableData: [
      //   {
      //     name: "Pay Groups Seleted",
      //     count: "0"
      //   },
      //   {
      //     name: "Total Head Count",
      //     count: "0"
      //   },
      //   {
      //     name: "New Joiners",
      //     count: "0"
      //   },
      //   {
      //     name: "Exits",
      //     count: "0"
      //   },
      //   {
      //     name: "Eligible Employees",
      //     count: "0"
      //   },
      //   {
      //     name: "Ineligible Employees",
      //     count: "0"
      //   },
      //   {
      //     name: "LOP Registered",
      //     count: "0"
      //   },
      //   {
      //     name: "RLOP Registered",
      //     count: "0"
      //   },
      //   {
      //     name: "Variable Earnings",
      //     count: "0"
      //   },
      //   {
      //     name: "Variable Deductions",
      //     count: "0"
      //   },
      //   {
      //     name: "TDS Overriden Amount",
      //     count: "0"
      //   }
      // ],

      offCycleData: [
        {
          name: "Total Head Count",
          count: "0"
        },      
        {
          name: "LOP Registered",
          count: "0"
        },
        {
          name: "RLOP Registered",
          count: "0"
        },
        {
          name: "Variable Earnings",
          count: "0"
        },
        {
          name: "Variable Deductions",
          count: "0"
        },
        {
          name: "TDS Overriden Amount",
          count: "0"
        }
      ],
      // PL_2957
      showModal: false,

      // Data type added By Bhushan Tipre 
      employeeData: [],
      page: 1,
      employeeTableColumns: [
        {
          label: "Employee Code",
          key: "code"
        },
        {
          label: "Name",
          key: "name"
        },
        {
          label: "Locations",
          key: "location"
        },
        {
          label: "Designation",
          key: "designation"
        }
      ],
      employeeIds: []
    };
  },
  activated() {
    // Here added By Bhushan Tipre 
    this.page = 1;
    this.employeeData = [];
    //this.fetchemp();
    if(this.le_id == this.selectedEmployeesList[0].le_id){
        this.employeeData = this.selectedEmployeesList[0].employees
    }
    this.fetchOffPayrollSummaryData();
  },
  mounted() {
    // Here added By Bhushan Tipre
    this.employeeData = [];
    if(this.le_id == this.selectedEmployeesList[0].le_id){
        this.employeeData = this.selectedEmployeesList[0].employees
    }
    this.fetchOffPayrollSummaryData();
  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    ...mapState({
      summaryData: state => state.payroll.runpayroll.summary,
      payGroupsData: state => state.payroll.paygroups.data,
      payrollMonth: state => state.payroll.runpayroll.payrollMonth,
      payrollYear: state => state.payroll.runpayroll.payrollYear
    }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    },
    ...mapState({
        selectedEmployeesList: state => state.payroll.selectedemployee.employeeDataForOffCycle,
    }),
  },
  methods: {
    ...mapActions({
      act_fetchAll: "payroll/runpayroll/fetchAll",
      act_create: "payroll/runpayroll/create",
      act_fetch: "onboard/employees/fetchAll",  // Here added By Bhushan Tipre
      act_get_off_payroll_summary: "payroll/selectedemployee/createSummaryData"
    }),

    cancel() {
      this.$router.push({
        path: `/payroll/run/${this.$route.params.entity_index}/tdsForOffPayroll`
      });
    },

    /** Function to fetch the data to show in the table from server */
    async fetchAll() {
      try {
        this.toast = false;
        this.errmsg = "";

        let selectedPayGroupsIds = [];

        if (
          this.payGroupsData[this.le_id] &&
          this.payGroupsData[this.le_id].length
        ) {
          for (let i = 0; i < this.payGroupsData[this.le_id].length; i++) {
            let obj = this.payGroupsData[this.le_id][i];
            selectedPayGroupsIds.push(obj.id);
          }
        } else {
          this.toast = true;
          this.errmsg =
            "Please select atleast one Pay group to run the payroll";
          return;
        }

        let obj = {
          data: {
            le_id: this.le_id,
            selectedPaygroups: selectedPayGroupsIds,
            // start PL-1974
            /*** Send payroll processing month enum dynamically ***/
            processing_payroll_month: this.getSelectedMonthEnumByName(
              this.payrollMonth
            ),
            /*** Send payroll processing month enum dynamically ***/
            financial_year: this.payrollYear
            // end PL-1974
          }
        };

        try {
          let res = await this.act_fetchAll(obj);

          if (res.status) {
            // PL_2957
            let dataPayload = res.data.payload;
            if (dataPayload.paygroupSeleted) {
              this.tableData[0].count = dataPayload.paygroupSeleted;
            }
            if (dataPayload.totalHeadCount) {
              this.tableData[1].count = dataPayload.totalHeadCount;
            }
            if (dataPayload.newJoineese) {
              this.tableData[2].count = dataPayload.newJoineese;
            }
            if (dataPayload.exits) {
              this.tableData[3].count = dataPayload.exits;
            }
            if (dataPayload.eligibleEmployees) {
              this.tableData[4].count = dataPayload.eligibleEmployees;
            }
            if (dataPayload.ineligilityEmployees) {
              this.tableData[5].count = dataPayload.ineligilityEmployees;
            }
            if (dataPayload.lopRegistred) {
              this.tableData[6].count = dataPayload.lopRegistred;
            }
            if (dataPayload.rlopRegistred) {
              this.tableData[7].count = dataPayload.rlopRegistred;
            }
            if (dataPayload.variableEarnings) {
              this.tableData[8].count = dataPayload.variableEarnings;
            }
            if (dataPayload.variableDeductions) {
              this.tableData[9].count = dataPayload.variableDeductions;
            }
            if (dataPayload.tdsOverridenAmount) {
              this.tableData[10].count = dataPayload.tdsOverridenAmount;
            }
            // PL_2957
          }
        } catch (err) {
          this.toast = true;
          this.errmsg = err;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    async fetchOffPayrollSummaryData() {
      try {
        let employeeIds = []
        this.employeeData.map(element => {
          employeeIds.push(element.empId);
        })
        let data = {
          le_id: this.le_id,
          processing_payroll_month: this.getSelectedMonthEnumByName(
            this.payrollMonth
          ),
          financial_year: this.payrollYear,
          employeeIds:  employeeIds
        };
        let res = await this.act_get_off_payroll_summary({data});
        if (res.data.status) {
              this.offCycleData[0].count = res.data.payload.totalHeadCount;
              this.offCycleData[1].count = res.data.payload.lopRegistred;
              this.offCycleData[2].count = res.data.payload.rlopRegistred;
              this.offCycleData[3].count = res.data.payload.variableEarnings;
              this.offCycleData[4].count = res.data.payload.variableDeductions;
              this.offCycleData[5].count = res.data.payload.tdsOverridenAmount;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    runPayrollClick() {
      this.performAction();
    },
    /** To hide the success popup and to navigate to the other screens */
    closeModal() {
      try {
        this.showModal = false;
        this.$router.push({
          name: "dashboardSubstep",
          params: {
            step_name: "payroll",
            sub_step: "monthlypayroll",
            runbckg: true
          }
        });
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** Function to submit the form data to server */
    async performAction() {
      try {
          let employeeIds = []
        this.employeeData.map(element => {
          employeeIds.push(element.empId);
        })
          try {
          let obj = {
            legal_entity_id: this.le_id,
            month: this.payrollMonth,
            // start PL-1974
            // start PL-2656
            financial_year: this.payrollYear,
            // end PL-1974
            // end PL-2656
            employeeIds: employeeIds,
            paygroups: [] // Here added By Bhushan Tipre
          };
          this.$root._data.isSaving = true;
          let data = await this.act_create(obj);

          setTimeout(() => {
            if (data.status) {
              this.showModal = true; //PL-2010
              this.responseMessage = data.data.message;
            }
            this.$root._data.isSaving = false;
          }, 500);
        } catch (err) {
          this.$root._data.isSaving = false;
          this.errmsg = err;
          this.toast = true;
        }
    } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** Function to return the selected month enum */
    getSelectedMonthEnumByName(selectedMonth) {
      try {
        let selectedMonthEnum = "";
        switch (selectedMonth) {
          case "January":
            selectedMonthEnum = "jan";
            break;
          case "February":
            selectedMonthEnum = "feb";
            break;
          case "March":
            selectedMonthEnum = "mar";
            break;
          case "April":
            selectedMonthEnum = "apr";
            break;
          case "May":
            selectedMonthEnum = "may";
            break;
          case "June":
            selectedMonthEnum = "jun";
            break;
          case "July":
            selectedMonthEnum = "jul";
            break;
          case "August":
            selectedMonthEnum = "aug";
            break;
          case "September":
            selectedMonthEnum = "sep";
            break;
          case "October":
            selectedMonthEnum = "oct";
            break;
          case "November":
            selectedMonthEnum = "nov";
            break;
          case "December":
            selectedMonthEnum = "dec"; // PL-2264
            break;

          default:
            break;
        }
        return selectedMonthEnum; // Enum type - values :  ['jan', 'feb','mar', 'apr','may', 'jun','jul', 'aug','sep', 'oct','nov', 'dec']
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /** Here Four functions added By Bhushan Tipre
     * async fetchemp()
     *  headerCheckBoxChange(isChecked, records)
     * selected(records, record)
     * deselected(records, record)
     * 
     * */
    // async fetchemp() {
    //   try {
    //     let res = await this.act_fetch({ le_id: this.le_id, page: this.page });
    //     if (res.data.status) {
    //       let empList = [];
    //       this.totalEmployees = res.data.payload.total;
    //       res.data.payload.data.forEach(element => {
    //         empList.push({
    //           id: element.id,
    //           name:
    //             element.first_name +
    //             " " +
    //             (element.last_name ? element.last_name : ""),
    //           code: element.code,
    //           // location: element.EmployeeOfficial
    //           //   ? this.getLocationName(element)
    //           //   : "",   // PL_3031
    //           // designation: element.EmployeeOfficial
    //           //   ? this.getDesignationName(element)
    //           //   : ""    // PL_3031
    //         });
    //       });
    //       this.employeeData.push(...empList);
    //       //this.tempList = this.employeeData;
    //     }
    //   } catch (err) {
    //     this.toast = true;
    //     this.errmsg = err;
    //   }
    // },

    headerCheckBoxChange(isChecked, records) {
      if (isChecked) {
        this.employeeIds = [];
        this.checkboxFlag = true;
        records.forEach( element => {
          this.employeeIds.push(
            element.id,
          );
        })
        this.records = records;
      } else {
        this.checkboxFlag = false;
        this.employeeIds = [];
      }
    },

    selected(records, record) {
      try {
        if(records.length > 0) {
          this.checkboxFlag = true; 
          this.employeeIds = [];
          records.forEach( element => {
            this.employeeIds.push(
              element.id,
            );
          })
          this.records = records;
        } else {
          this.checkboxFlag = false;
          this.employeeIds = [];
        }
        //this.checkboxFlag ? this.checkboxFlag = false :this.checkboxFlag = true
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
     }
    },

    deselected(records, record) {
      try {
       this.checkboxFlag ? this.checkboxFlag = false :this.checkboxFlag = true  ;
       this.records = records;
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
  }
};
</script>
<style lang="scss" scoped>
@import "../../../../../../scss/_variables.scss";

.margin-top-30 {
  margin-top: 30px;
}

.margin-bottom-100 {
  margin-bottom: 100px;
}

table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 60%;
}

td,
th {
  border: 1px solid #ffffff;
  text-align: left;
  padding: 8px;
  height: 50px;
}

tr:nth-child(even) {
  background-color: #f3f2f2; // #F9F9F9;
}
.summaryDiv {
  display: inherit;
  cursor: pointer;
  grid-template-columns: repeat(4/2fr);
  grid-template-rows: auto;
  grid-gap: 2px;
  padding: 0px;
  justify-content: space-between;
}

/* The Close Button */
.close {
  color: #ffffff;
  float: right;
  font-size: 40px;
  font-weight: normal;
  position: absolute;
  right: 10px;
}

.close:hover,
.close:focus {
  color: #d8d8d8;
  text-decoration: none;
  cursor: pointer;
}
.progress {
  width: 120px;
  height: 25px;
  background-color: $color-secondary;
  position: relative;
  -webkit-animation: mymove 3s; /* Safari 4.0 - 8.0 */
  -webkit-animation-iteration-count: infinite; /* Safari 4.0 - 8.0 */
  -webkit-animation-timing-function: linear;
  animation: mymove 3s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}

/* Safari 4.0 - 8.0 */
@-webkit-keyframes mymove {
  from {
    left: 0%;
  }
  to {
    left: 90%;
  }
}

@keyframes mymove {
  from {
    left: 0%;
  }
  to {
    left: 90%;
  }
}
</style>
